import React from 'react'
import {Container,Row,Col} from 'react-bootstrap'
import '../Styles/contactenos.css'
import Map  from './Map'

import emailjs from '@emailjs/browser';


const contactenos = () => {

  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_eas94ln', 'template_d8saunn',e.target, 'XmbPhp7_D1AQo06cs')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  }
  return (
    
    <Container fluid="md" id="contactenos">
        <Row >
          <Col>
            <div id="Titulo">
              <h2 >Contáctenos</h2>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <ul className="contactenos">
              <li>Numero de Whatsapp: <b>(+51) 999-467-372</b></li>
              <li>Siguenos en Facebook : <a href="https://www.facebook.com/Miladetallesparaelhogar">Mila de talles para el hogar</a></li>
              <li>Siguenos en Instagram : <a href="https://www.instagram.com/mila_detalles/">Mila Detalles - Instagram</a></li>
              <li>Dirección: <b>📌 Av. Aviación 5024, Surco- Lima - Perú  <br></br>|Polvos de Higuereta</b> - Tiendas 126 - 154</li>
            </ul>
            <div className="mapa">
                <Map />
            </div>
          </Col>
          <Col>
            <form onSubmit={sendEmail}>
                <b>
                  Si tienes alguna consulta, duda, recomendación o mejora, no dudes en mandarnos un mensaje, te lo agradeceríamos. 😊
                </b>
              <div className="mb-3">
                <label>Nombre</label>
                <input type="text" placeholder="Ingrese su nombre completo" name='nombre' title="Escriba solamente su nombre" pattern="[A-Za-z]{3,11}"/>
              </div>
              <div className="mb-3">
                <label>Direccion de correo</label>
                <input  type="email" placeholder="Ingrese su correo" name='correo' pattern='[A-Za-z0-9.+-_]+@[a-z]+\[a-z]{2,3}'/>
                <i>
                  Toda su informacion nunca sera compartida a terceros.
                </i>
              </div>

              <div className="mb-3">
                <label>Telefono celular</label>
                <input type="text" placeholder="Telefono celular" name='telefono' pattern="[0-9]{9,11}" title='La cantidad de digitos para un telefono puede ser de 9 a 11 digitos'/>
              </div>
             

              <div className="mb-3">
                <label>Tu Mensaje</label>      
                <textarea className="form-control" placeholder="Escribe aquí tu mensaje" name='mensaje'/>
              </div>
              
              <input type="submit" className='btn btn-warning' value= 'Enviar'/>
            </form>
          </Col>
        </Row>
    </Container>
  )
}

export default contactenos
